import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { AuthService } from '../../../services/apis/platform/auth.service';
import { UsuarioLoginResponse } from '../../../services/responses/platform/usuario-login.response';

@Component({
  selector: 'app-action-user',
  imports: [MatButtonModule],
  templateUrl: './action-user.component.html',
  styleUrl: './action-user.component.css',
})
export class ActionUserComponent implements OnInit {
  @Input() showActionUser: boolean;
  @Output() showActionUserFalse = new EventEmitter<number>();
  @Output() logout = new EventEmitter<number>();
  public userLoginResponse: UsuarioLoginResponse;

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.userLoginResponse = this.authService.getUserInfos();
  }
 
  clickContainerOut(): void {
    this.showActionUserFalse.emit();
  }

  clickLogout(): void {
    this.authService.logout();
    this.logout.emit();
  }
}
